const analyticsNames = {
	age: 'Users age',
	gender: 'User\'s gender',
	goal: 'User\'s goal',
	goalB: 'User\'s goal',
	activities_preferences: 'User\'s preferred activities',
	height: 'User\'s height',
	weight: 'User\'s current weight',
	target_weight: 'User\'s goal weight',
	diet_type: 'User\'s diet type',
	intermittent_fasting: 'Intermittent fasting',
	current_level: 'User\'s current fitness level',
	zones: 'User\'s preferred body zones',
	fat: 'Body fat',
	choose_days: 'Choose days when you want to work out',
	muscle_focus: 'Do you have certain muscle groups to focus on?',
	pushUps: 'How many push-ups can you do?',
	result_page_step: 'Start your weight loss plan now!'
};

export default analyticsNames;
